import { DatePicker, Stack, tryParseJSONObject } from '@fox/atoms';
import moment, { Moment } from 'moment';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { ActionCentreFilterProps, Range } from './contracts';
const DateLabelColor = styled.div`
	label {
		color: ${props => props.theme.palette.text.disabled};
	}
`;
export function DateRangeFilter({ column, onChange, filter, align }: ActionCentreFilterProps) {
	const value = useRef<Range | undefined>(undefined);
	const parsedValue = filter?.filterValue ? tryParseJSONObject<Range>(filter?.filterValue) : undefined;
	return (
		<DateLabelColor>
			<Stack direction={align} spacing={2}>
				<DatePicker
					fullWidth
					value={parsedValue?.gte ? moment(parsedValue.gte) : null}
					label={`${column.title} (from)`}
					onChange={(date: Moment | null) => {
						if (date && date.isValid() === false) {
							if (!value.current?.lte) {
								value.current = undefined;
							} else {
								value.current = { lte: value.current.lte };
							}
						} else {
							value.current = { ...value.current, gte: date?.toISOString() };
						}
						onChange(JSON.stringify(value.current));
					}}
					size="small"
				/>
				<DatePicker
					fullWidth
					value={parsedValue?.lte ? moment(parsedValue.lte) : null}
					label={`${column.title} (to)`}
					onChange={(date: Moment | null) => {
						if (date && date.isValid() === false) {
							if (!value.current?.gte) {
								value.current = undefined;
							} else {
								value.current = { gte: value.current.gte };
							}
						} else {
							value.current = { ...value.current, lte: date?.toISOString() };
						}
						onChange(JSON.stringify(value.current));
					}}
					size="small"
				/>
			</Stack>
		</DateLabelColor>
	);
}
